@if (isDataLoaded) {
  <div class="container resources-container"
    >
    <!-- Heading -->
    <div class="row">
      <div class="col"
        align="left">
        <h1 i18n class="blue-resources-heading">
        Resources
      </h1>
      </div>
      <div class="col" align="right">
        @if (showMenu) {
          <app-menu></app-menu>
        }
      </div>
    </div>
    @if (!showPdf) {
      <div style="margin-top: 16px;">
        @if (!isDownloading) {
          <button mat-stroked-button (click)="downloadAll()" style="color: #003F61; border-color: #003F61;">
            <mat-icon style="vertical-align: middle; margin-right: 4px;">download</mat-icon>
            <span i18n>Download All Resources</span>
          </button>
        }
        @if (isDownloading) {
          <div style="display: flex; align-items: center; gap: 12px;">
            <mat-progress-bar mode="determinate" [value]="downloadProgress" style="flex: 1; max-width: 300px;"></mat-progress-bar>
            <span class="descriptive-text" style="font-size: 14px;">{{ downloadProgress }}%</span>
          </div>
        }
      </div>
    }
    @if (!showPdf) {
      <div>
        <h3 i18n class="blue-resources-subheading">
      Species Identification Guides
    </h3>
        <mat-selection-list [multiple]="false" hideSingleSelectionIndicator>
          <mat-divider></mat-divider>
          @for (guide of speciesGuides; track guide; let index = $index) {
            <div>
              <mat-list-option (click)="resourceClick(0, index)">
                <span i18n class="list-item">
            {guide[0], select, Pacific Coastal Birds {Pacific Coastal Birds} Sturgeon ID Sheet {Sturgeon ID Sheet} Common Groundfish {Common Groundfish} Marine Mammal Guide {Marine Mammal Guide}}
          </span>
              </mat-list-option>
              <mat-divider></mat-divider>
            </div>
          }
        </mat-selection-list>
      </div>
    }
    @if (!showPdf) {
      <div class="row justify-content-center"
        >
        <div class="row info-section"></div>
      </div>
    }
    @if (!showPdf) {
      <div>
        <h3 i18n class="blue-resources-subheading" style="margin-top: 10px;">
      Maps
    </h3>
        @if (!logbooks.length) {
          <h6 i18n class="descriptive-text"
            >
      No available maps. Please add a logbook to view area maps.
    </h6>
        }
        @for (logbook of logbooks; track logbook) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span i18n class="list-item">
                  {logbook, select, Troll {Troll} Seine {Seine} Gill Net {Gillnet} All Area {All Area}} Maps
              </span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            @if (logbook === 'Gill Net') {
              <mat-selection-list [multiple]="false"
                hideSingleSelectionIndicator
                >
                <mat-divider></mat-divider>
                @for (map of gillNetMaps; track map; let index = $index) {
                  <div>
                    <mat-list-option (click)="resourceClick(1, index)">
                      <span i18n class="list-item">
              {map[0], select, License Areas (C-E) {License Areas (C-E)} Subareas For Nets {Subareas For Nets}}
            </span>
                    </mat-list-option>
                    <mat-divider></mat-divider>
                  </div>
                }
              </mat-selection-list>
            }
            @if (logbook === 'Seine') {
              <mat-selection-list [multiple]="false"
                hideSingleSelectionIndicator
                >
                <mat-divider></mat-divider>
                @for (map of seineMaps; track map; let index = $index) {
                  <div>
                    <mat-list-option (click)="resourceClick(2, index)">
                      <span class="list-item">
                        {map[0], select, License Areas (A-B) {License Areas (A-B)} Subareas For Nets {Subareas For Nets}}
                      </span>
                    </mat-list-option>
                    <mat-divider></mat-divider>
                  </div>
                }
              </mat-selection-list>
            }
            @if (logbook === 'Troll') {
              <mat-selection-list [multiple]="false"
                hideSingleSelectionIndicator
                >
                <mat-divider></mat-divider>
                @for (map of trollMaps; track map; let index = $index) {
                  <div>
                    <mat-list-option (click)="resourceClick(3, index)">
                      <span class="list-item">
                        {map[0], select, License Areas (F-H) {License Areas (F-H)} Zones and Subareas For Troll {Zones and Subareas For Troll}}
                      </span>
                    </mat-list-option>
                    <mat-divider></mat-divider>
                  </div>
                }
              </mat-selection-list>
            }
            @if (logbook === 'All Area') {
              <mat-selection-list [multiple]="false"
                hideSingleSelectionIndicator
                >
                <mat-divider></mat-divider>
                @for (map of allAreaMaps; track map; let index = $index) {
                  <div>
                    <mat-list-option (click)="resourceClick(4, index)">
                      <span i18n class="list-item">
              {{ map[0] }}
            </span>
                    </mat-list-option>
                    <mat-divider></mat-divider>
                  </div>
                }
              </mat-selection-list>
            }
          </mat-expansion-panel>
        }
      </div>
    }
    <!-- External Links -->
    @if (!showPdf) {
      <div>
        <h3 i18n class="blue-resources-subheading" style="margin-top: 10px;">Links</h3>
        <mat-selection-list [multiple]="false" hideSingleSelectionIndicator>
          <mat-divider></mat-divider>
          <mat-list-option (click)="null">
            <a href="https://pacificwhale.org/what-we-do/research/learn-about-marine-life/whale-dolphin-tracker-live-sightins-map/"
               target="_blank"
               rel="noopener noreferrer"
               class="list-item"
               style="text-decoration: none;">
              <span i18n>Pacific Whale Foundation — Live Sightings Map</span>
              <mat-icon style="font-size: 16px; height: 16px; width: 16px; vertical-align: middle; margin-left: 4px;">open_in_new</mat-icon>
            </a>
          </mat-list-option>
          <mat-divider></mat-divider>
        </mat-selection-list>
      </div>
    }
    <!-- Back button -->
    @if (showPdf) {
      <div
        class="row">
        <div class="col">
          <button mat-button
            class="back-button"
            type="button"
            (click)="backToResources()">
            <mat-icon>
              arrow_back
            </mat-icon>
          </button>
        </div>
      </div>
    }
    <!-- Actual pdf; cannot put in div, messes up UI -->
    @if (showPdf) {
      <pdf-viewer
        [src]="path + filename"
        [original-size]="false"
      style="width: 100%; height: 100%;"></pdf-viewer>
    }
  </div>
}
